export const fontSize = {
  nano: '10px',
  mini: '12px',
  small: '14px',
  medium: '16px',
  large: '18px',
  extraLarge: '20px',
  huge: '24px',
};
